module.exports = __webpack_public_path__ + "static/media/sms-signup.e92125ef.svg";